module.exports = __webpack_public_path__ + "../static/img/layout-6.b63701a0.png";